import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalModule } from '../modal/modal.module';
import { ButtonModule } from '../button/button.module';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: 'confirm-modal.component.html',
  styles: [
    `
      :host {
        display: content;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, ModalModule, ButtonModule],
})
export class ConfirmModalComponent {
  @Input()
  visible: boolean;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  modalTitle: string;
  @Input()
  modalMessage: string;

  @Output()
  readonly onNegativeClick = new EventEmitter<void>();
  @Output()
  readonly onPositiveClick = new EventEmitter<void>();

  onHiddenInternal() {
    this._emitClosed();
  }

  _onNegativeClick() {
    this.onNegativeClick.emit();
    this._emitClosed();
  }

  _onPositiveClick() {
    this.onPositiveClick.emit();
    this._emitClosed();
  }

  private _emitClosed() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
